import { Button, Dropdown, Menu, message, Switch, Tooltip, Modal } from "antd";
import ol from "openlayers";
import React from "react";
import {
  iconGeometry,
  QHC_Polygon,
  Google_Layer_Ve_Tinh,
  Google_Layer_Ban_Do,
  iconStyle,
  QHC_HienTrang,
  QHC_Test,
} from "../../../components/ListLayer";
import { AxiosGetSecretApi } from "../../../utils/fetchApi/index";
import StaticClass from "../../../utils/staticClass";
import Note from "../../TTQH/MapPopup/Note";
import "../MapQuyHoach/map-quy-hoach.scss";

class MapQuyHoach extends React.PureComponent {
  constructor(props) {
    super(props);
    this.map = {};
    this._layers = [];
    this._imgLayer = null;

    this.state = {
      checkedVeTinh: false,
      checkedBanDo: true,

      checkedBanDoGiay: false,

      dataBanDoGiay: {},
    };

    this._vectorLayer = null;
    this._iconGeometry = iconGeometry;

    this.BaseLayer = {
      Google_Layer_Ve_Tinh: Google_Layer_Ve_Tinh,
      Google_Layer_Ban_Do: Google_Layer_Ban_Do,
      QHC_Polygon: QHC_Polygon,
      QHC_HienTrang: QHC_HienTrang,
      QHC_Test:QHC_Test,
    };
  }

  async componentDidMount() {
    window.onbeforeunload = null;
    this.getBanDoGiay();
    this.getDataBanDoGiay();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isShowMenu !== this.props.isShowMenu) {
      if (this.map) {
        setTimeout(() => {
          this.map.updateSize();
        }, 1);
      }
    }
    if (prevProps.resetButton !== this.props.resetButton) {
      // this.setState({isShowButtonMap: false})
    }
  }

  async getBanDoGiay() {
    let res = await AxiosGetSecretApi(
      "/api/ban-do-giay/tim-theo-ma-chung?code=1"
    );
    if (res && Array.isArray(res) && res.length > 0 && res[0].URL) {
      this.setState({
        isShowButtonMap: true,
      });
      let extent = [res[0].Left, res[0].Bottom, res[0].Right, res[0].Top];
      extent = ol.proj.transformExtent(
        extent,
        ol.proj.get("EPSG:4326"),
        ol.proj.get("EPSG:3857")
      );

      // this.map.getView().setCenter(ol.extent.getCenter(extent));
      // this.map.getView().fit(extent, this.map.getSize(), { duration: 2000 });
      this._imgOvelayerLink = res[0].URL + "/" + res[0].Name;
      this.BaseLayer.QHC_RanhGioi = new ol.layer.Image({
        source: new ol.source.ImageStatic({
          url: res[0].URL + "/" + res[0].Name,
          imageExtent: extent,
        }),
      });
    }

    let resImgFull = await AxiosGetSecretApi(
      "/api/ban-do-giay/tim-theo-ma-chung?code=1a"
    );
    if (
      resImgFull &&
      Array.isArray(resImgFull) &&
      resImgFull.length > 0 &&
      resImgFull[0].URL
    ) {
      this.srcImgFull = resImgFull[0].URL + "/" + resImgFull[0].Name;
    }

    this.initMap();
  }

  async initMap() {
    let iconFeature = new ol.Feature({
      geometry: this._iconGeometry,
      name: "Null Island",
      population: 4000,
      rainfall: 500,
    });

    iconFeature.setStyle(iconStyle);

    let vectorSource = new ol.source.Vector({
      features: [iconFeature],
    });

    let vectorLayer = new ol.layer.Vector({
      source: vectorSource,
    });
    vectorLayer.setZIndex(99);

    this.BaseLayer.vectorLayer = vectorLayer;

    this._layers.push(this.BaseLayer.Google_Layer_Ban_Do);
    this._layers.push(this.BaseLayer.Google_Layer_Ve_Tinh);
    this._layers.push(this.BaseLayer.QHC_Polygon);
    this._layers.push(this.BaseLayer.QHC_HienTrang);
    this._layers.push(this.BaseLayer.QHC_RanhGioi);
    this._layers.push(this.BaseLayer.QHC_Test);
    this._layers.push(this.BaseLayer.vectorLayer);

    this.BaseLayer.QHC_RanhGioi.setVisible(false);
    this.BaseLayer.QHC_Test.setVisible(false);
    this.BaseLayer.QHC_Polygon.setVisible(true);
    this.BaseLayer.QHC_HienTrang.setVisible(true);

    this.BaseLayer.Google_Layer_Ban_Do.setVisible(true);
    this.BaseLayer.Google_Layer_Ve_Tinh.setVisible(false);
    this.BaseLayer.vectorLayer.setVisible(false);
    //end draw icon

    let container = document.getElementById("popup");
    let closer = document.getElementById("popup-closer");

    this._overlayPopup = new ol.Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    let seft = this;
    closer.onclick = function () {
      seft._overlayPopup.setPosition(undefined);
      closer.blur();
      return false;
    };

    this.map = new ol.Map({
      layers: [...this._layers],
      loadTilesWhileInteracting: true,
      target: "map",
      view: new ol.View({
        code: "EPSG:10775",
        center: [12045324.924720876, 1806357.9277613866],
        zoom: 14,
        minZoom: 6,
        maxZoom: 20,
      }),
      overlays: [this._overlayPopup],
      controls: ol.control.defaults({
        attribution: false,
        zoom: true,
      }),
    });
    // het ------------------------------------------------------------------------------------------------------------------

    this.map.on("singleclick", async(evt) => {
        // this.setLocation(evt.coordinate);
        let view = this.map.getView();
        let viewResolution = view.getResolution();
        let source = undefined;
        let source2 = undefined;
        let source3 = undefined;
        let url3 = '';

        source = this.BaseLayer.QHC_Polygon.getSource();
        source2 = this.BaseLayer.QHC_HienTrang.getSource();

        if(this.props.selectedNamQH === '2020'){
          source3 = this.BaseLayer.QHC_Test.getSource();
          url3 = source3.getGetFeatureInfoUrl(
            evt.coordinate,
            viewResolution,
            view.getProjection(),
            {
              INFO_FORMAT: "application/geojson",
              FEATURE_COUNT: "50",
            }
          );
          this.searchDuAnByClickTest(url3, evt);
          return;
        }

        let url1 = source.getGetFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {
            INFO_FORMAT: "application/geojson",
            FEATURE_COUNT: "50",
          }
        );

        let url2 = source2.getGetFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {
            INFO_FORMAT: "application/geojson",
            FEATURE_COUNT: "50",
          }
        );
      if (!this.state.checkedBanDoGiay) {
        if (source || source2) {
          this.searchDuAnByClick(url1, url2, evt);
        }
      } else {
          let res = await AxiosGetSecretApi(url1);
          if (
            res &&
            res.features &&
            Array.isArray(res.features) &&
            res.features.length !== 0 &&
            res.features[0].properties &&
            res.features[0].properties.OBJECTID
          ) {
            if (this.OBJECTID !== res.features[0].properties.OBJECTID) {
              this._coordinateOverlay = evt.coordinate;
              this.showOverLayeInfo();
            }
            return;
          }
      
          let res2 = await AxiosGetSecretApi(url2);
          if (
            res2 &&
            res2.features &&
            Array.isArray(res.features) &&
            res2.features.length !== 0 &&
            res2.features[0].properties &&
            res2.features[0].properties.OBJECTID
          ) {
            if (this.OBJECTID !== res2.features[0].properties.OBJECTID) {
              this._coordinateOverlay = evt.coordinate;
              this.showOverLayeInfo();
            }
            return;
          }
    
        message.error("Chưa có thông tin dự án (Dữ liệu đang cập nhật)");

      }
    });

    setTimeout(() => {
      this.map.updateSize();
    }, 1);
  }

  setLocation = (oo, zoom) => {
    this.map.getView().setCenter(oo);
    if (zoom) {
      this.map.getView().setZoom(zoom);
    }
    this._iconGeometry.setCoordinates(oo);
  };

  //--------------------ban do giay--------------------//
  async searchDuAnByClick(url1, url2, evt) {
    let res = await AxiosGetSecretApi(url1);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].properties &&
      res.features[0].properties.OBJECTID
    ) {
      if (this.OBJECTID !== res.features[0].properties.OBJECTID) {
        this.OBJECTID = res.features[0].properties.OBJECTID;
        this.props.searchDataTable(this.OBJECTID);
        this.setLocation(evt.coordinate);
      }
      return;
    }

    let res2 = await AxiosGetSecretApi(url2);
    if (
      res2 &&
      res2.features &&
      Array.isArray(res.features) &&
      res2.features.length !== 0 &&
      res2.features[0].properties &&
      res2.features[0].properties.OBJECTID
    ) {
      if (this.OBJECTID !== res2.features[0].properties.OBJECTID) {
        this.OBJECTID = res2.features[0].properties.OBJECTID;
        this.props.searchDataTable(this.OBJECTID);
        this.setLocation(evt.coordinate);
      }
      return;
    }

    message.error("Chưa có thông tin dự án (Dữ liệu đang cập nhật)");
  }

  async searchDuAnByClickTest(url1, evt) {
    let res = await AxiosGetSecretApi(url1);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].properties &&
      res.features[0].properties.OBJECTID
    ) {
      if (this.OBJECTID !== res.features[0].properties.OBJECTID) {
        this.OBJECTID = res.features[0].properties.OBJECTID;
        this.props.searchDataTable(this.OBJECTID);
        this.setLocation(evt.coordinate);
      }
      return;
    }

    message.error("Chưa có thông tin dự án (Dữ liệu đang cập nhật)");
  }

  onShowFullImg() {
    this.setState({
      isShowModal: true,
    });
  }

  onDownloadImgOverlay = () => {
    window.open(this._imgOvelayerLink, "_blank");
  };

  drawRing = (data) => {
    //draw line
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }

    // this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);

    if (data && data.length !== 0) {
      let listPoint = [];
      data.forEach((e) => {
        let x = new ol.Feature({
          geometry: new ol.geom.LineString(e),
        });
        listPoint.push(x);
      });

      let vectorSource = new ol.source.Vector({
        features: listPoint,
      });

      let aa = listPoint[0].getGeometry().getExtent();
      let oo = ol.extent.getCenter(aa);
      // this._iconGeometry.setCoordinates(oo);
      this.map.getView().setCenter(oo);

      this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

      if (this.map.getView().getZoom() > 21) {
        this.map.getView().setZoom(21);
      }

      if (this._vectorLayer) {
        this._vectorLayer.setSource(
          new ol.source.Vector({
            features: listPoint,
          })
        );
      } else {
        this._vectorLayer = new ol.layer.Vector({
          source: vectorSource,
          style: new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
            stroke: new ol.style.Stroke({
              color: "#00FFFF",
              width: 6,
            }),
            image: new ol.style.Circle({
              radius: 7,
              fill: new ol.style.Fill({
                color: "#ffcc33",
              }),
            }),
          }),
        });
        this.map.getLayers().push(this._vectorLayer);
      }
    }
  };

  handleCloseClick = (e) => {
    this.BaseLayer.vectorLayer.setVisible(false);
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }

    if (this._imgLayer) {
      this._imgLayer.setSource(undefined);
    }

    this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);
    this._overlayPopup.setPosition(undefined);
    this.onChangeBanDoGiay(false)
    // closer.blur();
  };

  //--------------------change ban do--------------------//
  onChangeBanDoSo(value, type) {
    switch (type) {
      case "BanDo":
        this.BaseLayer.Google_Layer_Ve_Tinh.setVisible(false);
        this.BaseLayer.Google_Layer_Ban_Do.setVisible(value);
        this.setState({
          checkedBanDo: value,
          checkedVeTinh: false,
        });
        break;

      case "VeTinh":
        this.BaseLayer.Google_Layer_Ve_Tinh.setVisible(value);
        this.BaseLayer.Google_Layer_Ban_Do.setVisible(false);
        this.setState({
          checkedBanDo: false,
          checkedVeTinh: value,
        });
        break;
    }
  }

  onChangeBanDoGiay(value) {
    this.BaseLayer.QHC_Polygon.setVisible(!value);
    this.BaseLayer.QHC_RanhGioi.setVisible(value);
    this.BaseLayer.QHC_Test.setVisible(false);
    this.setState({ checkedBanDoGiay: value });
    this._overlayPopup.setPosition(undefined);
  }

  // onChangeLayerByNamQH = (value) => {
  //   if(value === '2020'){
  //     this.BaseLayer.QHC_Polygon.setVisible(false);
  //     this.BaseLayer.QHC_RanhGioi.setVisible(false);
  //     this.BaseLayer.QHC_Test.setVisible(true);
  //   }else{
  //     this.BaseLayer.QHC_Polygon.setVisible(true);
  //     this.BaseLayer.QHC_RanhGioi.setVisible(false);
  //     this.BaseLayer.QHC_Test.setVisible(false);
  //   }
  //   this.setState({ checkedBanDoGiay: false });
  //   this._overlayPopup.setPosition(undefined);
  // }

  async getDataBanDoGiay() {
    let res = await AxiosGetSecretApi("/api/qh-chung/getAllNamQH");
    if (res && res.length !== 0) {
      let data = {
        ...res[0],
        NgayRaQD: res[0].NgayRaQD
          ? StaticClass.formatDate(res[0].NgayRaQD)
          : res[0].NgayRaQD,
      };
      this.setState({
        dataBanDoGiay: data,
      });
    }
  }

  showOverLayeInfo() {
    let _contentPopup = document.getElementById("popup-content");
    _contentPopup.innerHTML =
      '<div class="header-title-popup">Thông tin dự án</div>' +
      "</hr>" +
      `<div style="display: flex;">
              <div class="text-title-popup">Năm quy hoạch:</div>
              <div class="text-content-popup">${
                this.state.dataBanDoGiay && this.state.dataBanDoGiay.NamQH
                  ? this.state.dataBanDoGiay.NamQH
                  : "-"
              }</div>
          </div> 
    
          <div style="display: flex;">
              <div class="text-title-popup">Số quyết định:</div>
              <div class="text-content-popup">${
                this.state.dataBanDoGiay && this.state.dataBanDoGiay.QuyetDinh
                  ? this.state.dataBanDoGiay.QuyetDinh
                  : "-"
              }</div>
          </div> 
    
          <div style="display: flex;">
              <div class="text-title-popup">Ngày ra quyết định:</div>
              <div class="text-content-popup">${
                this.state.dataBanDoGiay && this.state.dataBanDoGiay.NgayRaQD
                  ? this.state.dataBanDoGiay.NgayRaQD
                  : "-"
              }</div>
          </div> `;
    this._overlayPopup.setPosition(this._coordinateOverlay);
  }
  //--------------------==========--------------------//
  getMyLocation() {
    const location = window.navigator && window.navigator.geolocation;
    if (location) {
      location.getCurrentPosition(
        (position) => {
          let data = {
            toaDoX: position.coords.longitude,
            toaDoY: position.coords.latitude,
            myLocation: true,
          };

          // this.jumpToLocation(data);
          let oo = ol.proj.transform(
            [parseFloat(data.toaDoX), parseFloat(data.toaDoY)],
            "EPSG:4326",
            "EPSG:3857"
          );
          this.setLocation(oo, 19);
          this.BaseLayer.vectorLayer.setVisible(true);
        },
        (error) => {
          message.error("Không thể xác định vị trí");
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: Infinity,
        }
      );
    }
  }
  render() {
    console.log('this.state.isShowButtonMap', this.state.isShowButtonMap);
    console.log('this.state.checkedBanDoGiay', this.state.checkedBanDoGiay);
    return (
      <div id="do-an-quy-hoach" className="map-quy-hoach">
        <div className="map-bound " id="map-bound">
          <div id="map" className="map quy-hoach-ol-map" ref="map ">
            <button
              className="button-location btn-geo-on-map map-control-button"
              onClick={() => {
                this.getMyLocation();
              }}
            >
              <i className="fas fa-location-arrow"></i>
            </button>

            <div className="map-button-quy-hoach">
              <Dropdown
                overlay={
                  <Menu className="menu-layer">
                    <Menu.Item key="VeTinh">
                      <div className="fl-bw">
                        <div className="text">Vệ tinh</div>
                        <Switch
                          checked={this.state.checkedVeTinh}
                          onChange={(value) => {
                            this.onChangeBanDoSo(value, "VeTinh");
                          }}
                        ></Switch>
                      </div>
                    </Menu.Item>
                    <Menu.Divider />

                    <Menu.Item key="BanDo">
                      <div className="fl-bw">
                        <div className="text">Đường phố</div>
                        <Switch
                          checked={this.state.checkedBanDo}
                          onChange={(value) => {
                            this.onChangeBanDoSo(value, "BanDo");
                          }}
                        ></Switch>
                      </div>
                    </Menu.Item>

                    <Menu.Divider />
                    <Menu.Item>
                      <div className="fl-bw">
                        <div className="text">Bản đồ giấy</div>
                        <Switch
                          checked={this.state.checkedBanDoGiay}
                          onChange={(value) => {
                            this.onChangeBanDoGiay(value);
                          }}
                        ></Switch>
                      </div>
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Tooltip title="Chuyển đổi nền" placement="bottomRight">
                  <button className="map-control-button-search button-left">
                    <i className="fas fa-map"></i>
                  </button>
                </Tooltip>
              </Dropdown>

              <Tooltip title="Chú giải" placement="bottom">
                <button className="map-control-button-search button-right">
                  <i
                    className="fas fa-list-ul"
                    onClick={() => {
                      this.setState({
                        isShowNotePopup: !this.state.isShowNotePopup,
                      });
                    }}
                  ></i>
                </button>
              </Tooltip>
            </div>

            {this.state.isShowNotePopup ? (
              <Note
                type="tab1"
                close={() => {
                  this.setState({ isShowNotePopup: false });
                }}
              ></Note>
            ) : null}

            {this.state.isShowButtonMap && this.state.checkedBanDoGiay ? (
              <div className="div-show-full">
                <Button
                  className="btn-show-full-img"
                  onClick={() => this.onShowFullImg()}
                  type="primary"
                >
                  Xem đầy đủ
                </Button>

                <Button
                  className="btn-show-full-img"
                  onClick={this.onDownloadImgOverlay}
                  type="primary"
                >
                  Tải về
                </Button>
              </div>
            ) : null}

            {this.state.isShowModal && (
              <Modal
                visible={this.state.isShowModal}
                onCancel={() => {
                  this.setState({ isShowModal: false });
                }}
                footer={null}
                width={window.screen.width - 300}
                closable={false}
              >
                <img
                  // src={`https://sxd.sgmcvietnam.vn${this.srcImgFull}`}
                  src={`http://10.17.20.52${this.srcImgFull}`}
                  style={{ width: "100%", height: "auto" }}
                  alt=" "
                ></img>
              </Modal>
            )}
          </div>
        </div>

        <div id="popup" className="ol-popup">
          <a href="#" id="popup-closer" className="ol-popup-closer" />
          <div id="popup-content" />
        </div>
      </div>
    );
  }
}

export default MapQuyHoach;
